<!--
 * @Author: tony.zhu
 * @Date: 2025-09-26 14:24:45
 * @LastEditTime: 2025-11-07 14:14:07
 * @LastEditors: tony.zhu
 * @Description: 
-->

<template>
  <div
    :class="[
      'c-widget_menu',
      !$attrs.isFixedMenu ? 'is-narrow_widget_menu' : '',
    ]"
  >
    <div
      v-for="(item, index) in data.children"
      :key="index"
      :class="[
        'c-widget_menu__item',
        !$attrs.isFixedMenu ? 'is-narrow_item' : '',
        item.meta.isShowSecondaryMenu ? 'is-multiple' : '',
      ]"
    >
      <template v-if="item.meta.isShowSecondaryMenu">
        <!-- 多级展示 -->
        <CMenuGroupItem
          v-bind="$attrs"
          :data="item"
          v-on="$listeners"
        ></CMenuGroupItem>
      </template>
      <template v-else>
        <!-- 根级展示 -->
        <CMenuItem
          v-bind="$attrs"
          :data="item"
          :class="['cmenu_item_wrap', formatActiveRoute(item)]"
          @mousemove.native.stop="onMousemove"
          @click.native.stop="onRouter(item)"
          :isUseCustomStr="$attrs.isFixedMenu"
          :customStr="item.meta.title"
          :isDisabled="true"
        >
          <div class="icon_wrap" style="display: flex; align-items: center">
            <!-- <CustomSvgIcon :icon-class="item.meta.icon" class="icon" /> -->
            <img src="@/components/aiChat/images/svg/xinjianduihuaIcon.svg" class="icon"/>
          </div>
          <template slot="title">
            <Tooltip
              :data="item.meta"
              :disabled="true"
              v-bind="$attrs"
              :keyName="$attrs.isFixedMenu ? 'title' : 'packName'"
              class="label"
            ></Tooltip>
          </template>
        </CMenuItem>
      </template>
    </div>
  </div>
</template>

<script>
import CMenuItem from "./menuItem.vue";
import CMenuGroupItem from "./menuGroupItem.vue";
import Tooltip from "@/components/aiChat/components/tooltip/tooltip.vue";
import { fetchEventSourceManager } from "@/components/aiChat/utils/fetchEventSourceManager.js";

export default {
  components: {
    CMenuItem,
    CMenuGroupItem,
    Tooltip,
  },
  props: {
    data: {
      type: Object,
      default() {
        return {
          children: [],
        };
      },
    },
  },
  computed: {
    formatActiveRoute() {
      return function (params) {
        let str = "";
        if (this.$attrs?.activeRouteProp === null) {
          str = "is-active";
        }
        return str;
      };
    },
  },
  methods: {
    onMousemove() {
      if (this.$attrs.isFixedMenu) return;
      try {
        this.$bus.emit("on-change-narrow-children", { bool: false, data: {} });
      } catch (error) {
        this.$bus.$emit("on-change-narrow-children", { bool: false, data: {} });
      }
    },

    onRouter(params) {
      // const loading = fetchEventSourceManager.onGetLoading();
      // if (loading) {
      //   fetchEventSourceManager.onCloseLink({ isManualClose: true });
      // }
      try {
        this.$bus.emit("on-change-field-by-custom-textarea", {
          key: "isSleep",
          value: false,
        });
      } catch (error) {
        this.$bus.$emit("on-change-field-by-custom-textarea", {
          key: "isSleep",
          value: false,
        });
      }
      const timer = setTimeout(() => {
        this.$emit("update:activeRouteProp", null);
        clearTimeout(timer);
      }, 10);
    },
  },
};
</script>

<style lang="scss" scoped>
.c-widget_menu {
  margin-top: 16px;
  padding: 0 0 0 16px;
  .c-widget_menu__item {
    margin-bottom: 4px;
    padding-right: 16px;
    &.is-multiple {
      padding-right: 0px;
    }

    &:last-child {
      margin-bottom: 0;
    }
    .is-narrow_item {
      margin-bottom: 24px;
      padding-right: 15px;
      min-width: 63px;
    }
    .cmenu_item_wrap {
      background: #e8f3ff;
      border-radius: 8px;
      box-shadow: none;
      .label {
        font-weight: 500;
        color: #165dff !important;
      }
      &.is-active {
        box-shadow: none;
      }
      &:hover {
        background: #d2e7fe;
      }
    }
  }
  .is-narrow_widget_menu {
    margin-top: 24px;
    padding-right: 0;
  }
  .icon_wrap{
    img{
          vertical-align: top;
    }
  }
}
</style>